import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { SwitchInCell } from './SwitchInCell';
import get from 'lodash/fp/get';
export var ToggleCell = function (_a) {
    var _b;
    var rowData = _a.rowData, column = _a.column, onRowAction = _a.onRowAction;
    var inverse = !!((_b = column === null || column === void 0 ? void 0 : column.passProps) === null || _b === void 0 ? void 0 : _b.inverse);
    var rawValue = get(column.name, rowData);
    var value = inverse ? !rawValue : !!rawValue;
    var actionName = "toggle_".concat(column.name);
    var _c = React.useState(value), isChecked = _c[0], setIsChecked = _c[1];
    React.useEffect(function () {
        setIsChecked(value);
    }, [rowData.id]);
    var onSwitchChange = useCallback(function () {
        if (!onRowAction)
            return;
        var ret = onRowAction(rowData.id, actionName, !isChecked, rowData);
        if (ret) {
            // promise returned = we wait for result
            ret.then(function () { return setIsChecked(!isChecked); });
        }
        else {
            // no promise = we fake feedback
            setIsChecked(!isChecked);
        }
    }, [onRowAction, rowData.id, actionName, isChecked]);
    return _jsx(SwitchInCell, { checked: isChecked, onChange: onSwitchChange });
};
